import { styled, Typography, TypographyProps } from '@material-ui/core';

export const SAITextColor =
  'linear-gradient(92deg, var(--Setvi-Blue-800, #00101E) 9.04%, var(--Purple-600, #5B69CC) 100.47%)';

const Title = styled(Typography)({
  width: 'fit-content',
  fontWeight: 'bold',
  background: SAITextColor,
  fontSize: 32,
  lineHeight: '40px',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent'
});

interface AITitle extends TypographyProps {
  children: React.ReactNode;
}

export const SAITitle = ({ children, ...rest }: AITitle) => (
  <Title {...rest}>{children} </Title>
);
